import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, take } from 'rxjs';
import { RootState } from '../../core/stores/store';
import { selectAppError } from '../../core/stores/app/app.selectors';
import { AppActions } from '../../core/stores/app/app.actions';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ErrorService } from '../../core/local-services/error.service';
import { Error } from '../../shared/interfaces/error.interfaces';

@Component({
  selector: 'app-error',
  imports: [
    CommonModule,
    MatIconModule,
    TranslateModule,
  ],
  templateUrl: './error.component.html',
  styleUrl: './error.component.scss'
})

export class ErrorComponent implements OnInit {

  error$: Observable<any>;
  errorMessage: string = ""

  constructor(
    private store: Store<RootState>,
    private translateService: TranslateService,
    private errorService: ErrorService
  ) {
    this.error$ = this.store.select(selectAppError);
    this.translateService.setDefaultLang('en');
    this.translateService.use(this.translateService.getBrowserLang() || 'en');
  }

  ngOnInit(): void {
    this.error$.pipe(take(1)).subscribe((serverError: Error) => {
      this.errorMessage = this.errorService.handleErrorMessage(serverError);
    });
  }

  dismissError() {
    this.store.dispatch(AppActions.unsetError());
  }

}
